import type { TFunction } from 'i18next';
import { ApiError } from './api.ts';

/**
 * Traduzione dei messaggi che arrivano dall'API.
 *
 * L'API restituisce una chiave nella forma `namespace.chiave`
 * (`errors.invalid_credentials`), mentre i18next separa il namespace con i
 * due punti. La conversione sta qui e non sparsa nei componenti: è il genere
 * di dettaglio che, ripetuto, prima o poi viene dimenticato in un punto e
 * mostra a una persona la stringa `errors.unexpected`.
 */
export function apiMessage(
  t: TFunction,
  messageKey: string,
  values: Record<string, unknown> = {},
): string {
  const separator = messageKey.indexOf('.');
  if (separator === -1) return t(messageKey, values);
  const namespace = messageKey.slice(0, separator);
  const key = messageKey.slice(separator + 1);
  return t(`${namespace}:${key}`, values);
}

/**
 * Il messaggio di un errore qualunque, che venga dall'API o da altrove.
 *
 * Tre schermate scrivevano queste tre righe identiche. Quello che si compra
 * estraendole non è la lunghezza: è che ci sia **un solo** posto in cui si
 * decide cosa si mostra quando l'errore non è nostro — oggi `errors.unexpected`,
 * e domani quello che sarà.
 */
export function errorMessage(t: TFunction, error: unknown): string {
  return apiMessage(t, error instanceof ApiError ? error.messageKey : 'errors.unexpected');
}
